{
  "fr": {
    "integration": {
      "actions": {
        "goTo": "Aller vers {name}"
      },
      "labels": {
        "apiTokensUsedByYou": "API tokens",
        "create_failed": "Failed to create",
        "crm_id": "{integration_oid_type} ID in {integration_name}: {integration_oid}",
        "description": "Description",
        "error": "error",
        "integration": "Intégration",
        "integrationOID": "Intégration ID",
        "last_sync_with": "Last synchronization with {integration_name} ({last_sync_at})",
        "status": "status",
        "synced_at": "Dernière synchronisation: ",
        "title": "Vos intégrations",
        "update_failed": "failed to update"
      },
      "record_actions": {
        "assign_customer": "Attribuez le client dans {integration_name}. L'association des clients y est gérée.",
        "delete": "Pour que {record_type} soit définitivement supprimé sur Ziggu (et ne réapparaisse pas), le {record_type} <strong>doit d'abord être supprimé sur {integration_name}</strong>."
      },
      "toasts": {
        "update": "Intégration mise en jour"
      }
    }
  }
}
